module.exports = __webpack_public_path__ + "img/cathedrale_groupe_recadre.cd31e67d.jpg";